// extracted by css-extract-rspack-plugin
export default {"prequal":"PrequalBlock-module__prequal___qXdxD","reject":"PrequalBlock-module__reject___G6mcx","accept":"PrequalBlock-module__accept___lo4hk"};